import type { User } from "../../../lecturas-common/models/administration/user.model";
import { DataSource } from "./data-source";

export class UsersDataSource extends DataSource<User>{
    constructor(){
                super("api/users")
                
    
        }
}

